import React from 'react'
const Button = React.lazy(() => import('@material-ui/core/Button'));
const Typography = React.lazy(() => import('@material-ui/core/Typography'));
import * as types from '@components/layout/modals/types';
import {Input} from '@components/form/Input';
import {Select} from "@components/form/Select";
import {connect} from 'react-redux';
import {history} from '~/router/history';
import {SimpleDialog} from "@components/form/SimpleDialog";
import Grid from "@material-ui/core/Grid";
import withStyles from '@material-ui/core/styles/withStyles';
import combineStyles from '~/utils/styles';
import form from '@style/form'
import modal from '@style/modal'
import clsx from "clsx";

class ModalWindowManagerComponent extends React.Component {
    state = {
        form: {},
        errors: [],
    };

    close = () => {
        this.submitModal();
    }

    submitModal = async () => {
        const response = await this.props.submitModal(this.props.id, this.state.form);
        if (response.errors) {
            this.setState({errors: response.errors});
        } else {
            history.go();
        }
    }

    componentDidMount() {
        const fields = this.props.payload.fields || [];
        let selectValues = {};
        fields.forEach(field => {
            if (field.defaultValue) {
                selectValues[field.name] = field.defaultValue;
            } else {
                if (field.type === types.FIELD_SELECT) {
                    selectValues[field.name] = field.value[Object.keys(field.value)[0]];
                }
            }
        })
        this.setState({form: selectValues});
    }

    renderForm = () => {
        const fields = this.props.payload.fields || [];

        return fields.map((field, i) => {
            switch (field.type) {
                case types.FIELD_STRING:
                    return <Input
                        value={this.state.form[field.name] || ''}
                        name={field.name}
                        errors={this.state.errors}
                        variant="outlined"
                        margin="normal"
                        required
                        size="small"
                        fullWidth
                        id={field.name}
                        label={field.title}
                        key={i}
                        onChange={({ target: { value } }) => this.setState({ form: { ...this.state.form, [field.name]: value } })}
                    />
                case types.FIELD_SELECT:
                    return <Select
                        variant="outlined"
                        size="small"
                        margin="normal"
                        label={field.title}
                        name={field.name}
                        errors={this.state.errors}
                        options={Object.keys(field.value).map((key) => {
                            return {label: field.value[key], value: key}
                        })}
                        fullWidth
                        key={i}
                        value={this.state.form[field.name] ?? 'UAH'}
                        onChange={({ target: { value } }) => this.setState({ form: { ...this.state.form, [field.name]: value } })}
                    />
            }
        });
    }

    renderButtonsBlock = () => {
        return [
            (<>
                {this.isClosable()
                    ? <Button
                        onClick={(e) => this.close()}
                        color="primary"
                        variant={'outlined'}
                    >
                        Закрыть
                    </Button>
                    : null
                }
            </>),
            (<Button
                color="primary"
                variant={'contained'}
                onClick={() => this.submitModal()}
            >
                {this.props.payload.actionButtonName || 'Ok'}
            </Button>),
        ].filter(action => action);
    }

    isClosable = () => {
        return !!this.props.is_closable;
    }

    isImage = () => {
        return !!this.props.image;
    }

    render() {
        const { classes } = this.props;

        return (
            <SimpleDialog
                disableCustomAction
                fullWidth={true}
                maxWidth={'md'}
                open={true}
                onClose={(e) => this.close()}
                title={this.props.title || ''}
                icon={<></>}
                actions={this.renderButtonsBlock()}
            >
                <Grid container spacing={3} className={classes.gridContainer}>
                    { this.isImage() ? <Grid item xs={12} md={4}>
                        <img width='100%' src={this.props.image} alt={this.props.title || ''}/>
                    </Grid> : null }

                    <Grid item xs={12} md={this.isImage() ? 8 : 12}>
                        <Typography
                            component="p"
                            className={clsx(classes.formLabel, {
                                [classes.formLabel_marginTop_downSm]: this.isImage(),
                            })}
                        >
                            {this.props.message}
                        </Typography>
                        {this.renderForm()}
                    </Grid>
                </Grid>
            </SimpleDialog>
        );
    }
}

export default connect(null, null)(withStyles(combineStyles(form, modal))(ModalWindowManagerComponent));
